import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import ContactType from '@/plugins/sdk/resources/Dictionary/ContactType'

export default class extends Resource {
  static name = 'account_contact'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      title: new STRING(),
      address: new STRING(),
      phone: new STRING(),
      mobile: new STRING(),
      email: new STRING(),
      notes: new STRING(),
      include_billing: new BOOLEAN(),
      include_pickups: new BOOLEAN(),
      deleted_at: new DATETIME(),
      account: new ITEM(Account),
      contact_type: new ITEM(ContactType)
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'title', label: 'Title' },
      { field: 'phone', label: 'Phone' },
      { field: 'mobile', label: 'Mobile' },
      { field: 'email', label: 'Email' },
      { field: 'include_billing', label: 'Include Billing' },
      { field: 'include_pickups', label: 'Include Pickups' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'account.account_name', label: 'Account Name' },
      { field: 'contact_type.name', label: 'Contact Type' }
    ]
  }
}
